import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const Herosection = ({ onExplorePress }) => {
  return (
    <section className="pt-24 pb-16 bg-gradient-to-br from-slate-950 via-black to-blue-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center space-x-2 bg-blue-400/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Icon name="Sparkles" size={16} className="text-blue-400" />
            <span className="text-white text-sm font-medium">Innovation Showcase</span>
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6">
            Portfolio of
            <span className="block text-gradient-gold">Technical Excellence</span>
          </h1>
          
          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8 text-center">
            Explore detailed case studies showcasing technical innovation, architectural decisions, 
            and measurable impact across web applications, mobile solutions, and community platforms.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <Button
              variant="default"
              iconName="Eye"
              iconPosition="right"
              className="bg-blue-600 text-white hover:bg-blue-700"
              onClick={onExplorePress}
            >
              Explore Projects
            </Button>
            <Button
              variant="outline"
              iconName="Download"
              iconPosition="right"
              className="border-blue-400/50 text-blue-100 hover:bg-blue-400/10"
              // onClick functionality will be implemented in the parent component
            >
              Download Portfolio
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Herosection;